module.exports = __webpack_public_path__ + "img/電気回路_6_3_2.8faa0452.png";